module.exports = __webpack_public_path__ + "img/phonepe@3x.b11fec4e.png";